import React from "react";
import { ShaderGradientCanvas, ShaderGradient } from "@shadergradient/react";
import styles from "./BackGrad.module.css";

function BackGrad() {
  return (
    <div className={styles.wrapper}>
      <ShaderGradientCanvas className={styles.canvas}>
        <ShaderGradient
          control="none"
          pointerEvents="none"
          color1="#660000"
          color2="#b4605e"
          color3="#8c0000"
        />
      </ShaderGradientCanvas>
    </div>
  );
}

export default BackGrad;
